/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { Button } from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import _map from 'lodash/map';

import {
  useGetMany,
  useDataProvider,
  useRefresh,
  useNotify,
  useUnselectAll,
} from 'react-admin';
import { STATUS } from '../helpers/constants';

const BulkArchiveButton = (props) => {
  const { data } = useGetMany(props.resource, props.selectedIds);

  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const dataProvider = useDataProvider();

  const handleClick = async () => {
    const sources = _map(data, (source) => ({
      ...source,
      status: STATUS.ARCHIVED,
    }));

    try {
      await dataProvider.updateMany(props.resource, {
        [props.resource]: sources,
      });
      unselectAll(props.resource);
      notify(`${props.resource}' status changed to 'archived'`);
    } catch (error) {
      notify(
        `${props.resource}'' status edit error: ${error.message}`,
        'warning'
      );
    } finally {
      refresh();
    }
  };

  return (
    <Button color="secondary" size="small" onClick={handleClick}>
      <ArchiveIcon />
      Archive
    </Button>
  );
};

export default BulkArchiveButton;
